export default __webpack_public_path__ + "static/media/cl-2.51034bad.jpg";